import { computable, observable } from "@chorda/core";
import { RowLayout } from "chorda-bulma";
import { COUNTRIES } from "../../data";
import { Select2, Option2 } from "./common/select2";
import { Paragraph, Text } from '../../helpers';
const countries = observable(COUNTRIES);
export default () => {
    return RowLayout([
        Select2({
            options$: () => countries,
            optionAs: Option2({
                text$: ({ option }) => option.name
            })
        }),
        {
            injections: {
                selected: () => observable('Andorra')
            },
            items: [
                Select2({
                    options$: () => countries,
                    value$: ({ selected }) => selected,
                    optionAs: Option2({
                        text$: ({ option }) => option.name
                    }),
                }),
                Text({
                    as: Paragraph,
                    text$: ({ selected }) => computable(() => `selected: ${selected}`)
                })
            ]
        },
        {
            injections: {
                selected: () => observable('TH')
            },
            items: [
                Select2({
                    options$: () => countries,
                    value$: (scope) => scope.selected,
                    optionAs: Option2({
                        text$: (scope) => scope.option.name,
                        key$: (scope) => scope.option.alpha2Code,
                    }),
                }),
                Text({
                    as: Paragraph,
                    text$: (scope) => computable(() => `selected: ${scope.selected}`)
                })
            ]
        },
    ]);
};
